import { MessagePlugin } from 'tdesign-react';

import { PromotionOrgDataKey } from '@/const/promotion';
import { IStory, IStoryRes } from '@/interface';
import { postMaterial } from '@/utils/material';
import { transformObjectDeep } from '@/utils/tans/object';

import { IPromotionItemInput, IPromotionItemOutput, IPromotionOutput, ItemManage } from './../interface/promotion';
import { apiPathServer } from './api-config';
import { CgiErrorCode, CgiResp } from './cgi';
import { OrgDataType, orgItemData } from './promotionData';
import { API_PREFIX, request } from './request';

/**
 * 保存单个Item信息
 */
export const modifyPromotionItemDetail = async (promotion: IPromotionItemInput) => {
  const { materialMap, ...propData }: any = promotion;
  propData.materialMap = postMaterial(propData, materialMap);
  let postData: IPromotionItemOutput = {};
  postData = orgItemData(OrgDataType.input, propData);
  const res = await request(`${API_PREFIX}${apiPathServer.postPromotionItem}`, {
    method: 'POST',
    body: transformObjectDeep({ data: postData }, 'snake'),
  });
  return res;
};

/**
 * 保存整体数据
 * @param promotion
 * @returns
 */
export const modifyPromotionDetail = async (promotion: IPromotionItemInput) => {
  const { ...propData }: any = promotion;
  const postData: IPromotionOutput = {
    id: propData?.id,
    itemList: propData?.promotionList?.map((e: { id: any; }) => ({ id: e?.id })),
    name: propData?.name,
  };
  const res = await request(`${API_PREFIX}${apiPathServer.postPromotion}`, {
    method: 'POST',
    body: transformObjectDeep({ data: postData }, 'snake'),
  });
  return res;
};

/**
 * copy项目信息
 */
export const copyPromotion = async (id: string) => {
  const res = await request(`${API_PREFIX}${apiPathServer.copyPromotion}`, {
    method: 'POST',
    body: { id },
  });
  return res;
};

/**
 * 删除配置信息
 */
export const deletePromotion = async (id: string) => {
  const res = await request(`${API_PREFIX}${apiPathServer.deletePromotion}`, {
    method: 'POST',
    body: { ids: [id] },
  });
  return res;
};


/**
 * 更改配置状态
 */
export const changePromotionIsUsed = async (params: {
  id: string;
  isUsed?: boolean;
}) => {
  const res = await request(`${API_PREFIX}${apiPathServer.updatePromotionFields}`, {
    method: 'POST',
    body: transformObjectDeep({ data: params }, 'snake'),
  });
  return res;
};

/**
 * 拉取Item详情接口
 */
export const fetchPromotionItemDetail = async (id: string) => {
  const res = await request<CgiResp<IStoryRes>>(`${API_PREFIX}${apiPathServer.promotionItemDetail}`, {
    query: {
      id,
    },
  });
  if (res.code !== CgiErrorCode.NO_ERROR) {
    MessagePlugin.error(res.message || '信息拉取失败，请稍后重试');
  }
  const turnData = transformObjectDeep(res?.data, 'camel') as IPromotionItemOutput;
  return {
    ...res,
    data: turnData,
  };
};

/**
 * 拉取整体详情接口
 */
export const fetchPromotionDetail = async (id: string) => {
  const res = await request<CgiResp<IStoryRes>>(`${API_PREFIX}${apiPathServer.promotionDetail}`, {
    query: {
      id,
    },
  });
  if (res.code !== CgiErrorCode.NO_ERROR) {
    MessagePlugin.error(res.message || '信息拉取失败，请稍后重试');
  }
  const turnData = transformObjectDeep(res?.data, 'camel') as IPromotionOutput;
  const data = turnData?.itemList?.map((e) => {
    const temp = orgItemData(OrgDataType.output, e);
    const dataKey = e?.managerType ? PromotionOrgDataKey[e?.managerType] : '';
    return {
      homeDataId: e?.homeDataId,
      managerType: e?.managerType,
      style: e?.style,
      id: e?.id,
      stories: temp?.stories,
      space: temp?.space,
      name: (e?.[dataKey as keyof IPromotionItemOutput] as ItemManage)?.name,
    };
  });
  // const
  const resultData = {
    name: turnData?.name,
    promotionList: data,
    id,
  };
  return {
    ...res,
    data: resultData,
  };
};

/**
 * 拉取列表
 * @param id
 * @returns
 */
export const fetchPromotionList = async ({
  page = 1,
  size = 10,
}: {
  page?: number;
  size?: number;
}): Promise<{
  list: IStory[];
  pageInfo: {
    total: number;
    current: number;
    pageSize: number;
  }
}> => {
  const res = await request(`${API_PREFIX}${apiPathServer.promotionList}`, {
    query: {
      page,
      size,
    },
  });
  const { list, pageinfo: pageInfo } = res?.data;
  return {
    list: list?.map((item: any) => transformObjectDeep(item, 'camel')) || [],
    pageInfo: {
      total: pageInfo?.total || 0,
      current: pageInfo?.page || 1,
      pageSize: pageInfo?.size || 10,
    },
  };
};
